import React, { useState } from "react";
import { NOW } from "@/lib/stages";
import { ukDayTime } from "@/lib/time";
import { Btn, Empty, Panel } from "./kit";

const WHO_REPLIED = { intro: "You replied", desk: "The introducer replied", hub: "The introducer replied" };
const by = (u, aud) => (u.via === "connexis" ? (aud === "hub" ? "posted by Connexis" : "posted by the Connexis desk")
  : u.via === "connie" ? "posted by Connie" : aud === "desk" && u.by ? `posted by ${u.by}` : aud === "hub" && u.by ? `posted by ${u.by}` : null);

/** Every Right now update on the case, newest first — who posted it, what it was waiting on, the next step, and any reply. */
const FIRST = 5;

export function UpdateHistory({ lanes, aud = "intro", testId = "update-history", hideEmpty = false }) {
  const [all, setAll] = useState(false);
  const every = (lanes || []).flatMap((l) => (l.updates || []).map((u) => ({ ...u, who: l.name })))
    .sort((a, b) => ((a.at || "") < (b.at || "") ? 1 : -1));
  const items = all ? every : every.slice(0, FIRST);
  if (hideEmpty && !every.length) return null;
  return (
    <Panel title="Right now updates" testId={testId}
           sub={`${aud === "desk" ? "Everything your desk has posted" : "Everything a lender has said is happening"} on this case, newest first. The stage stays the same while these change.`}>
      {items.length === 0 ? (
        <Empty testId={`${testId}-empty`}>No updates yet. When a lender posts one — trying to reach the client, a call back booked — it shows here.</Empty>
      ) : (
        <ol className="uh">
          {items.map((u, i) => (
            <li className="uh-row" key={`${u.at}-${i}`} data-testid={`${testId}-row-${i}`}>
              <i className="now-dot" style={{ background: NOW[u.key]?.pauses ? "#0055FF" : "#0D9488" }} />
              <div style={{ minWidth: 0 }}>
                <div className="uh-h">
                  <b data-testid={`${testId}-label-${i}`}>
                    {u.key === "callback" && u.callback_at ? `Call back booked for ${ukDayTime(u.callback_at, "a set time")}` : u.label}
                  </b>
                  <span>{[u.who, by(u, aud), ukDayTime(u.at, "—")].filter(Boolean).join(" · ")}</span>
                </div>
                <div className="uh-l"><span>Waiting on</span>{u.waiting}</div>
                <div className="uh-l"><span>Next step</span>{u.next}</div>
                {u.reply && (
                  <div className="uh-reply" data-testid={`${testId}-reply-${i}`}>
                    {WHO_REPLIED[aud]}: &ldquo;{u.reply.text}&rdquo; · {ukDayTime(u.reply.at, "—")}
                  </div>
                )}
              </div>
            </li>
          ))}
        </ol>
      )}
      {every.length > FIRST && (
        <div style={{ marginTop: 14 }}>
          <Btn sm onClick={() => setAll((v) => !v)} testId={`${testId}-toggle`}>
            {all ? "Show the latest only" : `Show all ${every.length} updates`}
          </Btn>
        </div>
      )}
    </Panel>
  );
}

export default UpdateHistory;
